class SRError extends Error {
    originalError?: Error;

    constructor(message: string, originalError?: unknown) {
        super(message);
        this.name = 'Search Ready Error';
        if (originalError) {
            this.originalError = this.createErrorFromUnknown(originalError);
        }
    }

    override toString() {
        return `${this.name}: ${this.message} \n ${this.originalError}`;
    }

    private createErrorFromUnknown(error: unknown): Error {
        if (error instanceof Error) {
            return error;
        }
        return new Error(String(error));
    }
}

export const isSRError = (error: unknown): error is SRError => {
    return error instanceof SRError;
};

export default SRError;
